export const submitContactForm = async body => {
  const data = await fetch(
    "https://jmmfw1lp57.execute-api.eu-central-1.amazonaws.com/test/dbmanager",
    {
      method: "post",
      body: JSON.stringify(body),
    }
  ).then(response => response.json())

  return data
}
